import { gql } from "@apollo/client";
import create from "zustand";

interface iProximityData {
    lat: number | null;
    long: number | null;
    rangeKm: number;
    inputValue: string;
}

interface iVacancySearchRadiusFilterStore {
    proximityWasCleared: boolean;
    proximityData: iProximityData;
    hasProximityData: () => boolean;
    setProximityData: (proximityData: iProximityData) => void;
    clearProximityData: () => void;
}

const useStore = create<iVacancySearchRadiusFilterStore>((set, get) => ({
    proximityWasCleared: false,
    proximityData: {
        lat: null,
        long: null,
        rangeKm: 20,
        inputValue: "",
    },
    hasProximityData: () => {
        const data = get().proximityData;
        return Boolean(data.lat && data.long && data.rangeKm);
    },
    setProximityData: (data) => {
        set({ proximityData: data, proximityWasCleared: false });
        const { proximityData } = get();

        if (proximityData.lat && proximityData.long && proximityData.rangeKm) {
            const url = new URL(window.location.href);
            url.searchParams.set("lat", proximityData.lat.toString());
            url.searchParams.set("long", proximityData.long.toString());
            url.searchParams.set("rangeKm", proximityData.rangeKm.toString());
            url.searchParams.set("address", proximityData.inputValue ?? "");

            window.history.pushState({ path: url.href }, "", url);
        }
    },
    clearProximityData: () => {
        set({
            proximityData: {
                ...get().proximityData,
                lat: null,
                long: null,
                inputValue: "",
            },
            proximityWasCleared: true,
        });
        const url = new URL(window.location.href);
        url.searchParams.delete("lat");
        url.searchParams.delete("long");
        url.searchParams.delete("rangeKm");
        url.searchParams.delete("address");
        window.history.pushState({ path: url.href }, "", url);
    },
}));

export const vacanciesWithinDistanceKmQuery = gql`
    query ($lat: Float!, $long: Float!, $rangeKm: Int!) {
        vacancies(
            withinDistanceKm: { lat: $lat, long: $long, distanceKm: $rangeKm }
        ) {
            company_name
            apply_online_link
            company_id
            external_posting_name
            geo_city
            geo_coordinates
            geo_country
            geo_name
            geo_state
            geo_street
            geo_zip
            id
            internal_posting_name
            internal_reference_id
            job_ad_url
            job_ad_text
            job_owner_avatarurl
            job_owner_city
            job_owner_email
            job_owner_firstname
            job_owner_function
            job_owner_lastname
            job_owner_phone
            job_owner_salutation
            job_owner_street
            job_owner_title
            job_owner_zip
            job_start_date
            keywords
            locale
            posting_last_updated_date
            project_number
            audiences {
                id
            }
            categories {
                id
            }
        }
    }
`;

export default useStore;
